import { render, staticRenderFns } from "./BlogArticleTile.vue?vue&type=template&id=0cc9681b&scoped=true&"
import script from "./BlogArticleTile.vue?vue&type=script&lang=ts&"
export * from "./BlogArticleTile.vue?vue&type=script&lang=ts&"
import style0 from "./BlogArticleTile.vue?vue&type=style&index=0&id=0cc9681b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc9681b",
  null
  
)

export default component.exports